import React, { useEffect, useState } from 'react';
import { Image } from "@chakra-ui/react";
import { toast, Toaster } from "react-hot-toast";
import { remark } from 'remark';
import html from 'remark-html';
import copy from '../assets/copy-dark.svg'
import '../../styles/markdown.scss';

export default function Answer({ answer }) {
    async function markdownToHtml(markdown) {
        try {
            const result = await remark().use(html).process(markdown);
            return result.toString();
        } catch (error) {
            console.error('Error converting Markdown to HTML:', error);
            return ''; // Handle error gracefully, return empty string or default content
        }
    }

    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        markdownToHtml(answer).then((html) => setHtmlContent(html));
    }, [answer]);

    return (
        <div
            className="container flex h-auto w-full shrink-0 gap-4 shadow-md rounded-lg border border-solid border-[#C2C2C2] p-5">
            <div className="w-full">
                <div className="flex items-center justify-between pb-3">
                    {answer && (
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(answer.trim());
                                    toast("Answer copied to clipboard", {
                                        icon: "✂️",
                                    });
                                }}
                            >
                                <Image
                                    src={copy}
                                    alt="footer"
                                    width={20}
                                    height={20}
                                    className="cursor-pointer"
                                />
                            </button>
                        </div>
                    )}
                </div>
                <div className="flex flex-wrap content-center items-center gap-[15px] pl-10 pr-10">
                    <div
                        className="w-full whitespace-pre-wrap text-base font-light leading-[152.5%] log-message">
                        {answer ? (
                            <div className="markdown-content" dangerouslySetInnerHTML={{ __html: htmlContent }}/>
                        ) : (
                            <div className="flex w-full flex-col gap-2">
                                <div className="h-6 w-full animate-pulse rounded-md"/>
                                <div className="h-6 w-full animate-pulse rounded-md"/>
                                <div className="h-6 w-full animate-pulse rounded-md"/>
                                <div className="h-6 w-full animate-pulse rounded-md"/>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Toaster
                position="top-center"
                reverseOrder={false}
                toastOptions={{ duration: 2000 }}
            />
        </div>
    );
}
